<div
  [ngClass]="{ tile: true, tileLink: link, disabled: disabled }"
  (click)="onClick()"
  (keydown.enter)="onClick()">
  @if (icon) {
    <icon [type]="icon"></icon>
  }
  <div>{{ label }}</div>
</div>
